/* eslint-disable react-hooks/exhaustive-deps */
import { RouteComponentProps, useLocation } from 'react-router'
import { useContext, useEffect } from 'react'

import { AnimatePresence, motion } from 'framer-motion'
import Padder from 'src/components/_layout/Padder/Padder'
import Loader from 'src/components/atoms/Loader/Loader'
import Composer from 'src/components/helpers/PageComposer/PageComposer'
import { ScrollbarContext } from 'src/context/scrollbar'
import { useGetPage } from 'src/queries'
import Footer from 'src/components/organisms/Footer/Footer'
import { useSelector } from 'react-redux'
import { getSettings } from 'src/selectors/settings'

type TParams = { page?: string }

const Page: React.FC<RouteComponentProps<TParams>> = ({
    match: {
        params: { page = 'home-page' },
    },
}) => {
    const { underConstruction } = useSelector(getSettings)

    const { error, data, isSuccess } = useGetPage(underConstruction ? 'landing' : page)
    const { scrollbar } = useContext(ScrollbarContext)

    useEffect(() => {
        if (isSuccess) {
            setTimeout(() => {
                scrollbar.current.scrollbar.update()
            }, 1000)
        }
    }, [isSuccess])
    const location = useLocation()

    if (error) return <h1>Something went wrong!</h1>
    return (
        <AnimatePresence>
            {isSuccess && (
                <motion.div
                    key="content"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ ease: 'easeOut', duration: 0.6 }}
                >
                    <Padder
                        top={{ '@initial': 'lg', '@md': location.pathname.includes('contatti') ? 'lg' : 'xl' }}
                        style={{ position: 'relative' }}
                    >
                        {data.acf.composer && <Composer components={data.acf.composer} />}

                        <Footer
                            pageId={data?.ID}
                            postType={data?.post_type}
                            showStandardFooter={data?.acf?.pageOptions?.showStandardFooter}
                        />
                    </Padder>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default Page
